<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <div class="card">
      <div class="card-body">
        <h3 class="p-2">
          รายงานประวัติลูกค้า
        </h3>
        <div>
          <h2 class="text-dark font-medium-3">
            <i class="fa fa-search" /> ค้นหา
          </h2>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label>ประวัติการเติมล่าสุด</label>

            <div class="input-group mb-1">
              <span class="input-group-text">วันที่</span>
              <flat-pickr
                v-model="dateStartTopup"
                class="form-control"
              />
              <span class="input-group-text">ถึง</span>
              <flat-pickr
                v-model="dateEndTopup"
                class="form-control"
              />

            </div>
          </div>
          <div class="col-md-4">
            <label>ประวัติการถอนล่าสุด</label>

            <div class="input-group mb-1">
              <span class="input-group-text">วันที่</span>
              <flat-pickr
                v-model="dateStartWithdraw"
                class="form-control"
              />
              <span class="input-group-text">ถึง</span>
              <flat-pickr
                v-model="dateEndWithdraw"
                class="form-control"
              />
            </div>

          </div>
          <div class="col-md-4">
            <label>ประวัติการเข้าใช้งานล่าสุด</label>

            <div class="input-group mb-1">
              <span class="input-group-text">วันที่</span>
              <flat-pickr
                v-model="dateStartUse"
                class="form-control"
              />
              <span class="input-group-text">ถึง</span>
              <flat-pickr
                v-model="dateEndWithUse"
                class="form-control"
              />
            </div>

          </div>
          <div class="col-md-2">
            <div
              class="form-group"
            >
              <label for="username">รหัสสมาชิก</label>
              <input
                v-model="search_userID"
                type="text"
                class="form-control"
                placeholder="รหัสสมาชิก"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div
              class="form-group"
            >
              <label for="username">ยอดการเติมล่าสุดมากกว่า</label>
              <input
                v-model="search_DesAmt"
                type="number"
                class="form-control"
                placeholder="ยอดฝาก"
              >
            </div>
          </div>
          <div class="col-md-2">
            <div
              class="form-group"
            >
              <label for="username">ยอดการถอนล่าสุดมากกว่า</label>
              <input
                v-model="search_WidAmt"
                type="number"
                class="form-control"
                placeholder="ยอดถอน"
              >
            </div>
          </div>
          <div class="col-md-12">
            <button
              class="btn btn-gradient-primary mr-1"
              @click="GetData()"
            >
              <feather-icon icon="SearchIcon" /> ค้นหา
            </button>
            <button
              class="btn btn-gradient-dark"
              @click="ClearFilter()"
            >
              ล้างค่า
            </button>
          </div>
        </div>

      </div>
    </div>
    <b-card
      no-body
    >
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">
          <div
            style="display: flex"
          >
            <b-button
              variant="gradient-primary"
              class="mr-1"
              @click="exportToExcel()"
            >
              โหลดไฟล์ Excel
            </b-button>
            <!-- <b-button

              variant="gradient-danger"
              @click="exportToPdf"
            >
              โหลดไฟล์ PDF
            </b-button> -->
          </div>
        </div>
      </b-card-body>
      <b-table
        ref="table"
        small
        striped
        hover
        responsive
        show-empty
        class="position-relative items-center"
        :per-page="perPage"
        :items="items"
        :fields="fields"
      >
        <template #empty="scope">
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40px"
            > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
          </div>
        </template>
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>
        <template #cell(userID)="data">
          {{ data.item.username }}
        </template>
        <template #cell(master)="data">
          {{ data.item.invited_by_name }}
        </template>
        <template #cell(balance)="data">
          {{ data.item.balance ? Commas(data.item.balance): 0 }}
        </template>
        <template #cell(HisLastDeposit)="data">
          {{ data.item.stamplast_deposit ? time(data.item.stamplast_deposit): null }}
        </template>
        <template #cell(LastDeposit)="data">
          {{ data.item.amountlast_deposit ? Commas(data.item.amountlast_deposit): 0 }}
        </template>
        <template #cell(HisLastWithdrawal)="data">
          {{ data.item.stamplast_withdraw ? time(data.item.stamplast_withdraw): null }}
        </template>
        <template #cell(LastWithdrawal)="data">
          {{ data.item.amountlast_withdraw ? Commas(data.item.amountlast_withdraw): 0 }}
        </template>
        <template #cell(HisLastUse)="data">
          {{ data.item.stamplast_login ? time(data.item.stamplast_login): null }}
        </template>
      </b-table>
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="getWithdraw()"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="GetData()"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>

  </b-overlay>
</template>

<script>
import moment from 'moment-timezone'
import {
  VBTooltip,
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BButton,
  BCardBody,
  VBToggle,
  BOverlay,
  BIconController,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    flatPickr,
    // BRow,
    // BCol,
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BCardBody,
    BOverlay,
    BIconController,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
    'b-tooltip': VBTooltip,
  },

  data() {
    return {
      perPage: 10,
      pageOptions: [10, 15, 20, 100, 500, 1000],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      NumberItem: [
        { value: 1, text: 100 },
        { value: 7, text: 500 },
        { value: 2, text: 1000 },
        { value: 3, text: 1500 },
        { value: 4, text: 2000 },
      ],

      fields: [
        { key: 'userID', label: 'รหัสสมาชิก' },
        { key: 'master', label: 'เซียน' },
        { key: 'balance', label: 'กระเป๋าเงิน' },
        { key: 'HisLastDeposit', label: 'ประวัติการเติมล่าสุด' },
        { key: 'LastDeposit', label: 'เติมล่าสุด' },
        { key: 'HisLastWithdrawal', label: 'ประวัติการถอนล่าสุด' },
        { key: 'LastWithdrawal', label: 'ถอนล่าสุด' },
        { key: 'HisLastUse', label: 'ประวัติการเข้าใช้งานล่าสุด' },
      ],

      items: [
        // {
        //   userID: '0999999999',
        //   master: '',
        //   HisLastDeposit: '23/12/2023',
        //   LastDeposit: 1,
        //   HisLastWithdrawal: '24/12/2023',
        //   LastWithdrawal: 0,
        //   HisLastUse: '24/12/2023',
        // },
      ],
      dateStartTopup: null,
      dateEndTopup: null,
      dateStartWithdraw: null,
      dateEndWithdraw: null,
      dateStartUse: null,
      dateEndWithUse: null,
      search_userID: null,
      search_DesAmt: null,
      search_WidAmt: null,
      show: false,
    }
  },
  mounted() {
    this.GetData()
  },
  methods: {
    time(data) {
      return moment(data).tz('Africa/Abidjan').format('DD/MM/YYYY HH:mm:ss')
      // return data
    },
    GetData() {
      this.show = true
      const params = {
        perPage: this.perPage,
        page: this.currentPage,
        dateStartTopup: this.dateStartTopup,
        dateEndTopup: this.dateEndTopup,
        dateStartWithdraw: this.dateStartWithdraw,
        dateEndWithdraw: this.dateEndWithdraw,
        dateStartUse: this.dateStartUse,
        dateEndWithUse: this.dateEndWithUse,
        search_userID: this.search_userID,
        search_DesAmt: this.search_DesAmt,
        search_WidAmt: this.search_WidAmt,
      }
      this.$http.get('/admin/GetCustomers', { params })
        .then(response => {
          response.data.data.forEach((ele, index) => {
            // eslint-disable-next-line no-param-reassign
            ele.balance = 0
            this.Getbalances(ele.uid, index)
          })
          this.items = response.data.data
          this.totalRows = response.data.total
          this.show = false
        }).catch(err => {
          console.log(err)
          this.show = false
        })
    },
    Getbalances(uid, index) {
      const params = {
        uid,
      }
      this.$http.get('/admin/Getbalance', { params })
        .then(response => {
          this.items[index].balance = response.data.balance
        })
        .catch(err => {
          console.log(err)
        })
    },
    exportToExcel() {
      this.show = true
      const params = {
        perPage: this.perPage,
        page: this.currentPage,
        dateStartTopup: this.dateStartTopup,
        dateEndTopup: this.dateEndTopup,
        dateStartWithdraw: this.dateStartWithdraw,
        dateEndWithdraw: this.dateEndWithdraw,
        dateStartUse: this.dateStartUse,
        dateEndWithUse: this.dateEndWithUse,
        search_userID: this.search_userID,
        search_DesAmt: this.search_DesAmt,
        search_WidAmt: this.search_WidAmt,
      }
      this.$http.get('/admin/export/Customer', { params })
        .then(response => {
          // console.log(response.data)
          const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = 'รายงานประวัติลูกค้า.xls' // ระบุชื่อไฟล์ที่ต้องการบันทึก
          link.click()
          this.show = false
        }).catch(err => {
          console.log(err)
          this.show = false
        })
    },
    Commas(x) {
      if (Math.round(x) !== x && x > 0) {
        const Num = Number(x)
        const y = Num.toFixed(2)
        return y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    ClearFilter() {
      this.dateStartTopup = null
      this.dateEndTopup = null
      this.dateStartWithdraw = null
      this.dateEndWithdraw = null
      this.dateStartUse = null
      this.dateEndWithUse = null
      this.search_userID = null
      this.search_DesAmt = null
      this.search_WidAmt = null
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.input-group-text {
    border-radius: 0;
}
</style>
